/** Column structure for the "Who We Serve" navigation group. */
export interface NavColumn {
  heading: string;
  headingTo?: string;
  links: { label: string; to: string }[];
}

export const whoWeServeColumns: NavColumn[] = [
  {
    heading: 'For Employers',
    headingTo: '/for-employers',
    links: [
      { label: 'Hiring Solutions', to: '/employers/hiring-solutions' },
      { label: 'Workforce Planning', to: '/employers/workforce-planning' },
      { label: 'Salary Benchmarking', to: '/services/executive-benchmarking' },
      { label: 'Employer Branding', to: '/employers/employer-branding' },
    ],
  },
  {
    heading: 'For Job Seekers',
    headingTo: '/for-candidates',
    links: [
      { label: 'Search Jobs', to: '/opportunities' },
      { label: 'Upload Resume', to: '/candidates/upload-resume' },
      { label: 'Career Advice', to: '/insights' },
      { label: 'Job Alerts', to: '/candidates/job-alerts' },
    ],
  },
  {
    heading: 'Industries',
    headingTo: '/industries',
    links: [
      { label: 'Technology', to: '/industries/technology-data-and-artificial-intelligence' },
      { label: 'Healthcare', to: '/industries/healthcare-and-health-technology' },
      { label: 'Finance', to: '/industries/financial-services' },
      { label: 'Artificial Intelligence', to: '/industries/technology-data-and-artificial-intelligence' },
    ],
  },
];
